import { OrderService } from '../../providers'
import { clearAffiliateKey, getAffiliateKey } from '../../utils/localStorage'

const OrderModule = {
  namespaced: true,
  state: {
    createOrderForm: {},
    createOrderResult: {},
    order: {},
    orders: [],
    ordersByUserId: [],
    ordersPageData: {},
    updateOrderByIdResult: {},
    updateOrderPaymentsResult: {},
    updateOrderPaymentsAttachmentResult: {},
    revenue: {}
  },
  mutations: {
    SET_CREATE_ORDER_FORM (state, data) {
      state.createOrderForm = data
    },
    SET_CREATE_ORDER_RESULT (state, data) {
      state.createOrderResult = data
    },
    SET_ORDER (state, data) {
      state.order = data
    },
    SET_ORDERS (state, data) {
      state.orders = data
    },
    SET_ORDERS_BY_USER_ID (state, data) {
      state.ordersByUserId = data
    },
    SET_ORDERS_PAGE_DATA (state, data) {
      state.ordersPageData = data
    },
    SET_UPDATE_ORDER_BY_ID_RESULT (state, data) {
      state.updateOrderByIdResult = data
    },
    SET_UPDATE_ORDER_PAYMENTS_RESULT (state, data) {
      state.updateOrderPayments = data
    },
    SET_UPDATE_ORDER_PAYMENTS_ATTACHMENT_RESULT (state, data) {
      state.updateOrderPaymentsAttachment = data
    },
    SET_REVENUE (state, data) {
      state.revenue = data
    }
  },
  actions: {
    async createOrder ({ commit }, params) {
      const affiliateKey = getAffiliateKey()
      const result = await OrderService.createOrder({ ...params, affiliateKey })
      clearAffiliateKey()

      commit('SET_CREATE_ORDER_RESULT', result)
      return result
    },
    async fetchOrderById ({ commit }, id) {
      const result = await OrderService.fetchOrderById(id)
      commit('SET_ORDER', result)
      return result
    },
    async fetchOrders ({ commit }, params) {
      const { orders, ...pageData } = await OrderService.fetchOrders(params)
      commit('SET_ORDERS', orders)
      commit('SET_ORDERS_PAGE_DATA', pageData)
      return orders
    },
    async fetchOrdersByUserId ({ commit }, params) {
      const result = await OrderService.fetchOrdersByUserId(params)
      commit('SET_ORDERS_BY_USER_ID', result)
      return result
    },
    async setCreateOrderForm ({ commit }, data) {
      commit('SET_CREATE_ORDER_FORM', data)
    },
    async updateOrderById ({ commit }, { id, params }) {
      const result = await OrderService.updateOrderById(id, params)
      commit('SET_UPDATE_ORDER_BY_ID_RESULT', result)
      return result
    },
    async updateOrderPayments ({ commit }, { id, params }) {
      const result = await OrderService.updateOrderPayments(id, params)
      commit('SET_UPDATE_ORDER_PAYMENTS_RESULT', result)
      return result
    },
    async deleteOrderById ({ commit, state }, orderId) {
      await OrderService.deleteOrderById(orderId)
      commit('SET_ORDERS', state.orders.filter((order) => order._id !== orderId))
    },
    async fetchRevenue ({ commit }, id) {
      const result = await OrderService.fetchRevenue(id)
      commit('SET_REVENUE', result)
      return result
    }
  },
  getters: {
    orderResultCode (state) {
      return state?.createOrderResult?.code || null
    }
  }
}

export default OrderModule
